import React, { useEffect, useState } from "react";
import { profile } from "../site";

/**
 * Brief entry sequence — echoes the "AHSAN" wordmark that was on the old
 * holding page. Never blocks: it lifts as soon as the page is ready (or after
 * a hard 1.1s ceiling), and is skipped entirely for reduced-motion users.
 */
export default function Intro() {
  const [done, setDone] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setGone(true);
      return undefined;
    }
    // Deterministic hold — long enough to read as an intended entry mark,
    // short enough that it never feels like a loading screen.
    const t = window.setTimeout(() => setDone(true), 780);
    return () => window.clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!done) return undefined;
    const t = window.setTimeout(() => setGone(true), 640);
    return () => window.clearTimeout(t);
  }, [done]);

  if (gone) return null;

  return (
    <div className={`intro${done ? " is-done" : ""}`} aria-hidden="true">
      <div className="intro__inner">
        <p className="intro__word">{profile.role}</p>
        <p className="intro__mark">{profile.name}</p>
        <div className="intro__bar" />
      </div>
    </div>
  );
}
